import React, {FC} from 'react';
import styled from 'styled-components';

import {useMeasureElement} from '../../../helpers/hooks/domHookHelpers';
import {CardModel} from '../../../models/api/cardModel';
import {VisualContactModel} from '../../../models/api/visualContactModel';
import {useContactDetailsContext} from '../contactDetailsContext';
import {ContactHeaderAccountContainer} from './contactHeaderAccountContainer';
import {ContactHeaderAvatarContainer} from './contactHeaderAvatarContainer';
import {ContactHeaderNameContainer} from './contactHeaderNameContainer';

/*
 * Props.
 */

interface ContactHeaderNameAndAvatarProps {
  contact?: VisualContactModel;
  card: CardModel | undefined;
}

/*
 * Styles.
 */

const StyledContactHeaderNameAndAvatarContainerDiv = styled.div`
  position: relative;
  display: flex;
  flex-flow: row;
  margin-bottom: 16px;

  &:last-child {
    margin-bottom: 0;
  }
`;

const StyledContactDetailsContainerDiv = styled.div`
  display: flex;
  flex-flow: column;
  vertical-align: middle;
  flex: 1;
  max-width: calc(100% - 60px);
  height: 48px;
`;

/*
 * Component.
 */

export const ContactHeaderNameAndAvatar: FC<ContactHeaderNameAndAvatarProps> = (props) => {
  const {contact, card} = props;
  const {panelId} = useContactDetailsContext();
  const [headerPanelRef, {width: headerPanelWidth}] = useMeasureElement();

  return (
    <StyledContactHeaderNameAndAvatarContainerDiv ref={headerPanelRef}>
      <ContactHeaderAvatarContainer card={card} contact={contact} />
      <StyledContactDetailsContainerDiv>
        <ContactHeaderNameContainer panelId={panelId} contact={contact} card={card} />
        <ContactHeaderAccountContainer
          card={card}
          contact={contact}
          panelId={panelId}
          popupWidth={headerPanelWidth + 32}
        />
      </StyledContactDetailsContainerDiv>
    </StyledContactHeaderNameAndAvatarContainerDiv>
  );
};
